import _ from "lodash";
import Grid from "@mui/material/Grid";
import React, { useState, useEffect } from "react";
import { Box } from "@mui/system";
import { makeStyles } from "@material-ui/core/styles";

const pathToParentMenu = ["root"];

const WwIconImage = (props) => {
  const classes = useStyles();
  let [classnames, setClassnames] = useState("");
  let [alignClass, setAlignClass] = useState("");
  //let [classnames, setClassnames] = useState('');

  useEffect(() => {
    if (
      props.data.style.decoration_classes !== null &&
      props.data.style.decoration_classes !== undefined
    ) {
      setClassnames(props.data.style.decoration_classes.join(" "));
    }

    //setClassnames(classnames + " slideInLeft q-pa-xs");

    if (
      props.data.style.align !== null &&
      props.data.style.align !== undefined &&
      props.data.style.align !== "center"
    ) {
      setAlignClass(props.data.style.align);
    } else {
      setAlignClass("");
    }
  }, [props.data]);

  return (
    <Grid container>
      <Grid item xs={12}>
        <Box
          sx={{
            position: "relative",
            margin: 0.5,
            maxWidth: "180px",
            borderRadius: "7px",
            border: "solid 0px red",
            textAlign: alignClass,
          }}
        >
          <img
            className={[classes.iconimg, classnames]}
            src={`${sessionStorage.getItem('media_url')}image/${props.data.source}`}
            width={props.data.style.width}
            height={props.data.style.height}
            id={props.data.myId.self}
            style={{display: props.initHide && props.initHide.indexOf(props.data.myId.self) > -1 ? 'none' : 'inline-block'}}
          />
        </Box>
      </Grid>
    </Grid>
  );
};
const useStyles = makeStyles({
  iconimg: {
    borderRadius: "7px",
  },
});
export default WwIconImage;
